import { DialogActions } from '@mui/material';

import { GDMDialogActionsComponent } from './GDMDialogActions.type';

/* TODO: Implement component using GDM default design */
const GDMDialogActions: GDMDialogActionsComponent = props => <DialogActions {...props} />;

export default GDMDialogActions;
